import React from "react";
import ChaptersVideo from "../../videos/a4h-video.mp4";
import logo from "../../images/A4HLOGO.png";
import chapter1 from "../../images/chapter1.jpg";
import arizona from "../../images/arizona.jpg";
import alabama from "../../images/alabama.jpg"
import alaska from "../../images/alaska.jpg"
import Arkansas from "../../images/arkansas.jpg"
import colorado from "../../images/colorado.jpg"
import connecticut from "../../images/connecticut.jpg"
import delaware from "../../images/delaware.jpg"
import florida from "../../images/florida.jpg"
import georgia from "../../images/georgia.jpg"
import hawaii from "../../images/hawaii.jpg"
import idaho from "../../images/idaho.jpg"
import llinois from "../../images/llinois.jpg"
import indiana from "../../images/indiana.jpg"
import iowa from "../../images/iowa.jpg"
import kansas from "../../images/kansas.jpg"
import kentucky from "../../images/kentucky.jpg"
import louisiana from "../../images/louisiana.jpg"
import maine from "../../images/maine.jpg"
import maryland from "../../images/maryland.jpg"
import massachusetts from "../../images/massachusetts.jpg"
import Michigan from "../../images/michigan.jpg"
import minnesota from "../../images/minnesota.jpg"
import mississippi from "../../images/mississippi.jpg"
import missouri from "../../images/missouri.jpg"
import montana from "../../images/montana.jpg"
import nebraska from "../../images/nebraska.jpg"
import nevada from "../../images/nevada.jpg"
import newhampshire from "../../images/NewHampshire.jpg"
import newjersey from "../../images/newjersey.jpg"
import newmexico from "../../images/newmexico.jpg"
import newyork from "../../images/newyork.jpg"
import northcarolina from "../../images/northcarolina.jpg"
import northdokota from "../../images/northdokota.jpg"
import ohio from "../../images/ohio.jpg"
import oregon from "../../images/oregon.jpg"
import oklahoma from "../../images/oklahoma.jpg"
import rhode from "../../images/rhodeisland.jpg"
import tennessee from "../../images/tennessee.jpg"
import texas from "../../images/texas.jpg"
import utah from "../../images/utah.jpg"
import virginia from "../../images/virginia.jpg"
import washington from "../../images/washington.jpg"
import washingtondc from "../../images/washingtondc.jpg"
import Pennsylvania from "../../images/Pennsylvania.jpg"
import SouthCarolina from "../../images/SouthCarolina.jpg"
import southdotaka from "../../images/South Dakota.jpg"
import vermont from "../../images/vermont.jpg"
import westvirginia from "../../images/westvirginia.jpg"
import wisconsin from "../../images/wisconsin.jpg"
import wyoming from "../../images/wyoming.jpg"
import california from "../../images/california.jpg"
import { Link, useNavigate } from "react-router-dom";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker
} from "react-simple-maps";
import MissionAndGoals from "./MISSIONANDGOALS";

const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

const colors = ["#8BE04E","#F6D743","#E67BA5","#B784E3","#F3A261"];

/* NORMAL STATE LABELS */
const stateLabels = [
{ name:"Alabama", coordinates:[-86.8,32.8]},
{ name:"Alaska", coordinates:[-150,64]},
{ name:"Arizona", coordinates:[-111.7,34.2]},
{ name:"Arkansas", coordinates:[-92.4,34.8]},
{ name:"California", coordinates:[-119.5,37]},
{ name:"Colorado", coordinates:[-105.5,39]},


{ name:"Florida", coordinates:[-81.5,27.8]},
{ name:"Georgia", coordinates:[-83.5,32.6]},
{ name:"Hawaii", coordinates:[-157.5,20.5]},
{ name:"Idaho", coordinates:[-114.2,44.2]},
{ name:"Illinois", coordinates:[-89.2,40]},
{ name:"Indiana", coordinates:[-86.1,39.9]},
{ name:"Iowa", coordinates:[-93.5,42]},
{ name:"Kansas", coordinates:[-98.2,38.5]},
{ name:"Kentucky", coordinates:[-84.8,37.5]},
{ name:"Louisiana", coordinates:[-91.8,30.9]},
{ name:"Maine", coordinates:[-69.1,45.3]},


{ name:"Michigan", coordinates:[-85.5,44.3]},
{ name:"Minnesota", coordinates:[-94.3,46]},
{ name:"Mississippi", coordinates:[-89.7,32.7]},
{ name:"Missouri", coordinates:[-92.5,38.5]},
{ name:"Montana", coordinates:[-110.4,46.8]},
{ name:"Nebraska", coordinates:[-99.7,41.5]},
{ name:"Nevada", coordinates:[-116.6,39.3]},


{ name:"New Mexico", coordinates:[-106.1,34.4]},
{ name:"New York", coordinates:[-75.5,43]},
{ name:"North Carolina", coordinates:[-79.4,35.5]},
{ name:"North Dakota", coordinates:[-100.5,47.5]},
{ name:"Ohio", coordinates:[-82.8,40.4]},
{ name:"Oklahoma", coordinates:[-97.5,35.5]},
{ name:"Oregon", coordinates:[-120.5,44]},
{ name:"Pennsylvania", coordinates:[-77.5,41]},

{ name:"South Carolina", coordinates:[-80.9,33.8]},
{ name:"South Dakota", coordinates:[-100,44.5]},
{ name:"Tennessee", coordinates:[-86.4,35.8]},
{ name:"Texas", coordinates:[-99.4,31]},
{ name:"Utah", coordinates:[-111.7,39.3]},

{ name:"Virginia", coordinates:[-78.8,37.5]},
{ name:"Washington", coordinates:[-120.7,47.5]},
{ name:"West Virginia", coordinates:[-80.6,38.6]},
{ name:"Wisconsin", coordinates:[-89.9,44.6]},
{ name:"Wyoming", coordinates:[-107.6,43]}
];

/* SMALL EAST COAST STATES WITH CALLOUT LINES */

const calloutStates = [
{ name:"Massachusetts", coordinates:[-71.8,42.3], dy:-25 },
{ name:"Connecticut", coordinates:[-72.7,41.6], dy:-5 },
{ name:"Rhode Island", coordinates:[-71.5,41.7], dy:15 },
{ name:"New Jersey", coordinates:[-74.5,40.1], dy:30 },
{ name:"Delaware", coordinates:[-75.5,39], dy:45 },
{ name:"Maryland", coordinates:[-76.7,39], dy:60 },

{ name:"Vermont", coordinates:[-72.7,44], dy:-20, side:"left" },
{ name:"New Hampshire", coordinates:[-71.6,43.8], dy:-40, side:"left" }
];

function A4HChapters(){
  const [showFlyer, setShowFlyer] = React.useState(false);
  
const [selectedState, setSelectedState] = React.useState("");
const navigate = useNavigate();
const [isMobile, setIsMobile] = React.useState(
  () => typeof window !== "undefined" && window.matchMedia("(max-width: 768px)").matches
);

React.useEffect(() => {
  const mq = window.matchMedia("(max-width: 768px)");
  const apply = () => setIsMobile(mq.matches);
  apply();
  if (mq.addEventListener) mq.addEventListener("change", apply);
  else mq.addListener(apply);
  return () => {
    if (mq.removeEventListener) mq.removeEventListener("change", apply);
    else mq.removeListener(apply);
  };
}, []);

const handleStateClick = (geo) => {
  
  const state = geo.properties.name;

  const route = stateRoutes[state];

  if (route) {
  navigate(route);
} else {
  setSelectedState(state);
  setShowFlyer(true);}}
  const stateRoutes = {
  "Alabama": "/services/STATES/ALABAMA",
  "Arizona": "/services/STATES/ARIZONA",
  "Arkansas": "/services/STATES/ARKANSAS",
  "California": "/services/STATES/CALIFORNIA",
  "Colorado": "/services/STATES/COLORADO",
  "Connecticut": "/services/STATES/CONNECTICUT",
  "Delaware": "/services/STATES/DELAWARE",
  "Florida": "/services/STATES/FLORIDA",
  "Georgia": "/services/STATES/GEORGIA",
  "Illinois": "/services/STATES/ILLINOIS",
  "Kansas": "/services/STATES/KANSAS",
  "Louisiana": "/services/STATES/LOUISIANA",
  "Maine": "/services/STATES/MAINE",
  "Maryland": "/services/STATES/MARYLAND",
  "Massachusetts": "/services/STATES/MASSACHUSETTS",
  "Michigan": "/services/STATES/MICHIGAN",
  "Missouri": "/services/STATES/MISSOURI",
  "Nevada": "/services/STATES/NEVADA",
  "New Hampshire": "/services/STATES/NEWHAMPSHIRE",
  "New Jersey": "/services/STATES/NEWJERSEY",
  "New Mexico": "/services/STATES/NEWMEXICO",
  "New York": "/services/STATES/NEWYORK",
  "North Carolina": "/services/STATES/NORTHCAROLINA",
  "Ohio": "/services/STATES/OHIO",
  "Oregon": "/services/STATES/OREGON",
  "Pennsylvania": "/services/STATES/PENNSYLVANIA",
  "Rhode Island": "/services/STATES/RHODEISLAND",
  "Tennessee": "/services/STATES/TENNESSEE",
  "Texas": "/services/STATES/TEXAS",
  "Utah": "/services/STATES/UTAH",
  "Virginia": "/services/STATES/VIRGINIA",
  "Washington": "/services/STATES/WASHINGTON"
};

return(
<>

<style>{`
.page-header{
width:100%;
text-align:center;
padding:25px 0 10px 0;
}

.page-header h1{
font-size:34px;
font-weight:700;
letter-spacing:3px;
color:#222;
margin:0;
}
.map-section{
  overflow:hidden;
  background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
  width: 100%;
  padding: 70px 40px;
}

.map-mobile-hint{
  display:none;
  text-align: center;
  font-size: 13px;
  color: #444;
  margin: 0 0 8px;
  font-weight: 600;
}

.map-container{
  width:100%;
  max-width:1500px;
  margin:0 auto;
  background: rgba(255,255,255,0.55);
  border-radius: 24px;
  border: 2px solid rgba(180, 110, 60, 0.35);
  box-shadow: 0 10px 28px rgba(0,0,0,0.12);
  overflow: hidden;
  padding: 10px;
}

.map-container svg{
  display:block;
  width: 100% !important;
  height: auto !important;
  margin: 0 !important;
  max-height: none;
}

.state{
stroke:#333;
stroke-width:0.6;
cursor:pointer;
}

.state:hover{
fill:#ff9933 !important;
}

.state-label{
font-size:12px;
font-weight:600;
fill:#222;
pointer-events:none;
}
.chapters-hero{
width:100%;
padding:70px 20px;
text-align:center;

background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
}

.chapters-hero-content{
max-width:900px;
margin:auto;
}

.chapters-hero h1{
font-size:48px;
font-weight:900;
letter-spacing:3px;
color:#3a0d00;
margin-bottom:15px;
}

.section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}

/* Subtitle */

.chapters-hero p{
font-size:16px;
color:#333;
}
.chapters-grid{
max-width:1200px;
margin:60px auto;
display:grid;
grid-template-columns:repeat(3,minmax(0,1fr));
gap:28px;
padding:0 28px;
}
.chapter-card{
background:#ffffff;
border-radius:18px;
padding:18px 16px 14px;
cursor:pointer;
transition:0.3s;
box-shadow:0 6px 18px rgba(0,0,0,0.15);
position:relative;
overflow:hidden;
display:flex;
flex-direction:column;
align-items:center;
min-height: 280px;
}

.chapter-card:hover{
transform:translateY(-6px);
}

.chapter-logo{
position:absolute;
top:12px;
right:12px;
width:56px;
height:56px;
z-index:5;
background:transparent;
padding:0;
box-shadow:none;
border-radius:0;
}

.chapter-logo img{
width:100%;
height:100%;
object-fit:contain;
}

.chapter-card > img{
  width:100%;
  height:280px;
  object-fit:cover;
  padding:0;
}

.chapter-title{
font-size:16px;
font-weight:700;
line-height:1.35;
text-align:center;
color:#000;
margin-top:auto;
}
.chapters-section{
width:100%;
background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
padding:70px 0;
}
.chapters-heading{
  text-align:center;
  margin-bottom:40px; /* space between heading and cards */
}

.chapters-heading h2{
  font-size:32px;
  font-weight:800;
  color:#b30000; /* strong red */
  letter-spacing:2px;
  margin-bottom:10px;
}
.upcoming-section{
  padding-top:0px;
}
  .flyer-overlay{
  position: fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background: rgba(0,0,0,0.6);
  display:flex;
  justify-content:center;
  align-items:center;
  z-index:999;
}

.flyer-box{
  background: linear-gradient(to right, #ffdb5e, #ffffff);
  padding:40px;
  border-radius:15px;
  text-align:center;
  width:400px;
  box-shadow:0 10px 30px rgba(0,0,0,0.3);
}

.flyer-box h2{
  color:#c4002f;
  font-size:26px;
}

.flyer-box h3{
  margin:10px 0;
  font-size:20px;
}

.flyer-box button{
  margin-top:15px;
  padding:10px 20px;
  background:#0b3d6d;
  color:white;
  border:none;
  border-radius:8px;
  cursor:pointer;
}
.senate-bar{
  width:100%;
  max-width:980px;

  margin:0 auto 50px;
  padding:14px 30px;

  position:relative;
  overflow:hidden;

  border-radius:18px;

  background:
    linear-gradient(
      to bottom,
      #ff6b6b 0%,
      #d4001f 35%,
      #980014 70%,
      #6b000d 100%
    );

  border:3px solid #7a1d00;

  box-shadow:
    inset 0 3px 8px rgba(255,255,255,0.35),
    inset 0 -4px 8px rgba(0,0,0,0.35),
    0 6px 18px rgba(0,0,0,0.28);
}

/* glossy shine */
.senate-bar::before{
  content:"";
  position:absolute;

  top:4px;
  left:10px;
  right:10px;

  height:45%;

  border-radius:20px;

  background:linear-gradient(
    to bottom,
    rgba(255,255,255,0.55),
    rgba(255,255,255,0.05)
  );
}

/* right golden shine */
.senate-bar::after{
  content:"";

  position:absolute;
  top:0;
  right:-60px;

  width:220px;
  height:100%;

  transform:skewX(-30deg);

  background:linear-gradient(
    to right,
    rgba(255,215,120,0),
    rgba(255,215,120,0.18),
    rgba(255,255,255,0.35),
    rgba(255,215,120,0)
  );
}

.senate-bar span{
  position:relative;
  z-index:2;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:12px;

  color:#fff;
  font-size:34px;
  font-weight:900;
  letter-spacing:3px;
  text-transform:uppercase;

  text-shadow:
    0 2px 5px rgba(0,0,0,0.45);
}
/* ===== PREMIUM VIDEO SECTION ===== */

.video-showcase-section{
  width:100%;
  padding:90px 40px;

  background:
    linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
}

.video-showcase-container{
    width:100% !important;
    max-width:1700px !important;
    margin:0 auto !important;
    padding:0 20px !important;
}

.video-frame{
    position:relative !important;
    width:100% !important;
    max-width:1500px !important;
    aspect-ratio:16/9 !important;
    margin:0 auto !important;
    padding:8px !important;
    border-radius:24px !important;
    overflow:hidden !important;
    background:linear-gradient(145deg,#ffffff,#f7f7f7) !important;
    box-shadow:0 12px 35px rgba(0,0,0,.25) !important;
    isolation:isolate !important;
}

.video-frame video{
    display:block !important;
    width:100% !important;
    height:100% !important;
    max-width:100% !important;
    max-height:none !important;
    object-fit:cover !important;
    object-position:center center !important;
    border-radius:18px !important;
    position:relative !important;
    z-index:2 !important;
    background:transparent !important;
}
@keyframes borderGlow{
    0%{filter:hue-rotate(0deg);}
    100%{filter:hue-rotate(360deg);}
}
/* ===== ULTRA PREMIUM VIDEO FRAME ===== */

.video-frame{
  position:relative;

  width:100%;
  overflow:hidden;

  padding:10px;
  border-radius:34px;

  background:
    linear-gradient(
      145deg,
      rgba(255,255,255,0.18),
      rgba(255,255,255,0.04)
    );

  backdrop-filter: blur(18px);

  box-shadow:
    0 20px 60px rgba(0,0,0,0.45),
    inset 0 1px 1px rgba(255,255,255,0.25),
    inset 0 -1px 1px rgba(255,255,255,0.08);

  transition:
    transform .6s ease,
    box-shadow .6s ease;
}

/* Rotating luxury border */
.video-frame::before{
    content:"";
    position:absolute;
    inset:0;
    border-radius:24px;
    padding:3px;
    background:linear-gradient(90deg,#ffcc00,#ff7b00,#ffd700,#ffcc00);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite:xor;
    mask-composite:exclude;
    animation:borderGlow 4s linear infinite;
    pointer-events:none;
}

/* Inner glass layer */
.video-frame::after{
  content:"";
  position:absolute;
  inset:4px;

  border-radius:30px;

  background:
    linear-gradient(
      145deg,
      rgba(20,20,20,0.20),
      rgba(255,255,255,0.04)
    );

  z-index:1;
}

/* VIDEO — natural aspect like other pages */
.video-frame video{
  position:relative;
  z-index:2;

  width:100%;
  height:auto;
  max-height:780px;

  object-fit:contain;
  display:block;
  background:#000;

  border-radius:24px;

  border:2px solid rgba(255,255,255,0.15);

  box-shadow:
    0 10px 30px rgba(0,0,0,0.35);

  transition:
    transform .6s ease,
    filter .6s ease;
}

/* Elegant shine */
.video-frame .video-shine{
  position:absolute;

  top:0;
  left:-120%;

  width:50%;
  height:100%;

  background:linear-gradient(
    90deg,
    transparent,
    rgba(255,255,255,0.35),
    transparent
  );

  transform:skewX(-25deg);

  z-index:3;

  animation: shineMove 5s infinite;
}

/* =========================
   MOBILE UI
   ========================= */
@media (max-width: 768px) {
  
  .page-header h1 {
    font-size: 22px;
    letter-spacing: 1px;
  }

  .chapters-hero {
    padding: 28px 16px 20px;
  }

  .chapters-hero h1 {
    font-size: 22px;
    line-height: 1.25;
    letter-spacing: 1px;
    margin-bottom: 10px;
  }

  .chapters-hero p {
    font-size: 14px;
    line-height: 1.5;
    padding: 0 4px;
  }

  .section-divider {
    margin: 14px auto 16px;
    gap: 10px;
  }

  .section-divider span {
    font-size: 16px;
  }

  /* Interactive US map — required on mobile */
  .map-section {
    display: block !important;
    padding: 24px 10px 28px !important;
  }

  .map-mobile-hint {
    display: block !important;
  }

  .map-container {
    width:100% !important;
    margin:0 auto !important;
    border-radius: 16px !important;
    padding: 8px 4px !important;
    max-width:1500px !important;
  }

  .map-container svg {
    margin: 0 !important;
    min-height: 300px !important;
    max-height: 420px !important;
    width: 100% !important;
    height: 72vw !important;
  }

  .state-label {
    font-size: 7px !important;
  }

  /* Replace clumsy video with the map */
  .video-showcase-section{
    display:block !important;
    width:100%;
    padding:34px 10px;
    overflow:hidden;
}

  .senate-bar {
    width: calc(100% - 24px);
    max-width: none;
    margin: 8px auto 18px;
    padding: 10px 12px;
    border-radius: 12px;
    border-width: 2px;
  }

  .senate-bar span {
    font-size: 14px;
    letter-spacing: 1px;
    gap: 6px;
    flex-wrap: wrap;
    text-align: center;
    line-height: 1.3;
  }

  .chapters-section {
    padding: 24px 0 20px;
  }

  .chapters-heading {
    margin-bottom: 16px;
    padding: 0 10px;
  }

  .chapters-heading h2 {
    font-size: 18px;
    letter-spacing: 1px;
    line-height: 1.3;
  }

  /* 2 columns — less clumsy on phones */
  .chapters-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 14px !important;
    margin: 0 auto 24px !important;
    padding: 0 12px !important;
  }

  .chapter-card {
    padding: 8px !important;
    border-radius: 12px !important;
    min-height: 205px !important;
    justify-content: flex-start !important;
}

.chapter-card > img{
    width:100%;
    height:120px;
    object-fit:contain;
    object-position:center;
    transform:scale(1.5);
    padding:0;
    margin-top:10px;
    margin-bottom:8px;
}

  .chapter-logo {
    top: 8px !important;
    right: 8px !important;
    width: 36px !important;
    height: 36px !important;
  }

  .chapter-title {
    display: block !important;
    position: relative !important;
    z-index: 6 !important;
    width: 100% !important;
    font-size: 13px !important;
    line-height: 1.3 !important;
    font-weight: 700 !important;
    color: #000 !important;
    background: #fff !important;
    margin-bottom: 0 !important;
    letter-spacing: 0 !important;
    padding: 0 2px;
  }

  .upcoming-section {
    padding-top: 0;
  }

  .flyer-overlay {
    padding: 16px;
    align-items: center;
  }

  .flyer-box {
    width: 100%;
    max-width: 340px;
    padding: 24px 18px;
    border-radius: 14px;
  }

  .flyer-box h2 {
    font-size: 20px;
  }

  .flyer-box h3 {
    font-size: 16px;
  }

  .flyer-box button {
    width: 100%;
    padding: 12px 16px;
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .chapters-hero h1 {
    font-size: 20px;
  }

  .map-container svg {
    max-height: 240px !important;
  }

  .chapters-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 12px !important;
    padding: 0 10px !important;
  }

  .chapter-card {
    padding: 8px !important;
    border-radius: 12px !important;
    min-height: 205px !important;
    justify-content: flex-start !important;
}

.chapter-card > img{
    width:100%;
    height:120px;
    object-fit:contain;
    object-position:center;
    transform:scale(1.8);
    padding:0;
    margin-top:10px;
    margin-bottom:8px;
}

  .chapter-logo {
    width: 32px !important;
    height: 32px !important;
  }

  .chapter-title {
    font-size: 12px !important;
    line-height: 1.3 !important;
  }

  .senate-bar span {
    font-size: 12px;
  }
}

`}</style>
<div className="chapters-hero">
  <div className="chapters-hero-content">
    <h1>A4H MULTIPLE STATE PACS </h1>
    
    <div className="section-divider">
  <span>✦ ✦ ✦</span>
</div>
    
    <p><strong>Explore all A4H PAC chapters across the UNITED STATES OF AMERICA.</strong></p>
  </div>
</div>
<div className="video-showcase-section">
  <div className="video-showcase-container">

    <div className="video-frame">

      <div className="video-shine"></div>

      <video
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={ChaptersVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

    </div>

  </div>
</div>
<div className="map-section">
  <p className="map-mobile-hint">Tap a state to open its A4H chapter</p>
  <div className="map-container">
    <ComposableMap
      projection="geoAlbersUsa"
      projectionConfig={{ scale: isMobile ? 1450 : 1650 }}
      width={1600}
      height={900}
      style={{
        width: "100%",
        height: "auto",
        display: "block",
      }}
    >
      <Geographies geography={geoUrl}>
        {({ geographies }) =>
          geographies.map((geo, index) => {
            const color = colors[index % colors.length];
            return (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill={color}
                className="state"
                onClick={() => handleStateClick(geo)}
              />
            );
          })
        }
      </Geographies>

      {!isMobile &&
        stateLabels.map((state) => (
          <Marker key={state.name} coordinates={state.coordinates}>
            <text textAnchor="middle" className="state-label">
              {state.name}
            </text>
          </Marker>
        ))}

      {!isMobile &&
        calloutStates.map((state) => {
          const isLeft = state.side === "left";
          return (
            <Marker key={state.name} coordinates={state.coordinates}>
              <g>
                <line
                  x1="0"
                  y1="0"
                  x2={isLeft ? -40 : 40}
                  y2={state.dy}
                  stroke="#333"
                  strokeWidth="0.6"
                />
                <text
                  x={isLeft ? -44 : 44}
                  y={state.dy}
                  textAnchor={isLeft ? "end" : "start"}
                  className="state-label"
                >
                  {state.name === "New Hampshire" ||
                  state.name === "Rhode Island" ? (
                    <>
                      <tspan x={isLeft ? -44 : 44} dy="0">
                        {state.name.split(" ")[0]}
                      </tspan>
                      <tspan x={isLeft ? -44 : 44} dy="9">
                        {state.name.split(" ")[1]}
                      </tspan>
                    </>
                  ) : (
                    state.name
                  )}
                </text>
              </g>
            </Marker>
          );
        })}
    </ComposableMap>
  </div>
</div>
{showFlyer && (
  <div className="flyer-overlay" onClick={() => setShowFlyer(false)}>
    <div className="flyer-box" onClick={(e) => e.stopPropagation()}>
      <h2>A4H PAC {selectedState}</h2>
      <h3>CHAPTER LAUNCHING SOON</h3>
      <button onClick={() => setShowFlyer(false)}>Close</button>
    </div>
  </div>
)}
{/* Video map removed — interactive US map above is mandatory */}
<div className="chapters-section">

  <div className="senate-bar">
  <span> Existing Chapters (38 Chapters)</span>
</div>

  <div className="chapters-grid">

<Link to="/services/STATES/ALABAMA" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={alabama} alt="A4H ALABAMA" />
  <div className="chapter-title">
    A4H PAC Alabama
  </div>
</Link>

<Link to="/services/STATES/ARKANSAS" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={Arkansas} alt="A4H ARKANSAS" />
  <div className="chapter-title">
    A4H PAC Arkansas
  </div>
</Link>

<Link to="/services/STATES/ARIZONA" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={arizona} alt="A4H ARIZONA" />
  <div className="chapter-title">
    A4H PAC Arizona
  </div>
</Link>

<Link to="/services/STATES/CALIFORNIA" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={california} alt="A4H CALIFORNIA" />
  <div className="chapter-title">
    A4H PAC California
  </div>
</Link>

<Link to="/services/STATES/COLORADO" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={colorado} alt="A4H COLORADO" />
  <div className="chapter-title">
    A4H PAC Colorado
  </div>
</Link>

<Link to="/services/STATES/CONNECTICUT" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={connecticut} alt="A4H CONNECTICUT" />
  <div className="chapter-title">
    A4H PAC Connecticut
  </div>
</Link>

<Link to="/services/STATES/DELAWARE" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={delaware} alt="A4H DELAWARE" />
  <div className="chapter-title">
    A4H PAC Delaware
  </div>
</Link>

<Link to="/services/STATES/FLORIDA" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={florida} alt="A4H FLORIDA" />
  <div className="chapter-title">
    A4H PAC Florida
  </div>
</Link>

<Link to="/services/STATES/GEORGIA" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={georgia} alt="A4H GEORGIA" />
  <div className="chapter-title">
    A4H PAC Georgia
  </div>
</Link>

<Link to="/services/STATES/ILLINOIS" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={llinois} alt="A4H ILLINOIS" />
  <div className="chapter-title">
    A4H PAC Illinois
  </div>
</Link>

<Link to="/services/STATES/KANSAS" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={kansas} alt="A4H KANSAS" />
  <div className="chapter-title">
    A4H PAC Kansas
  </div>
</Link>

<Link to="/services/STATES/LOUISIANA" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={louisiana} alt="A4H LOUISIANA" />
  <div className="chapter-title">
    A4H PAC Louisiana
  </div>
</Link>

<Link to="/services/STATES/MARYLAND" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={maryland} alt="A4H MARYLAND" />
  <div className="chapter-title">
    A4H PAC Maryland
  </div>
</Link>

<Link to="/services/STATES/MASSACHUSETTS" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={massachusetts} alt="A4H MASSACHUSETTS" />
  <div className="chapter-title">
    A4H PAC Massachusetts
  </div>
</Link>

<Link to="/services/STATES/MAINE" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={maine} alt="A4H MAINE" />
  <div className="chapter-title">
    A4H PAC Maine
  </div>
</Link>

<Link to="/services/STATES/MICHIGAN" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={Michigan} alt="A4H MICHIGAN" />
  <div className="chapter-title">
    A4H PAC Michigan
  </div>
</Link>

<Link to="/services/STATES/MISSOURI" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={missouri} alt="A4H MISSOURI" />
  <div className="chapter-title">
    A4H PAC Missouri
  </div>
</Link>

<Link to="/services/STATES/NEVADA" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={nevada} alt="A4H NEVADA" />
  <div className="chapter-title">
    A4H PAC Nevada
  </div>
</Link>

<Link to="/services/STATES/NEWMEXICO" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={newmexico} alt="A4H NEW MEXICO" />
  <div className="chapter-title">
    A4H PAC New Mexico
  </div>
</Link>

<Link to="/services/STATES/NEWHAMPSHIRE" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={newhampshire} alt="A4H NEWHAMPSHIRE" />
  <div className="chapter-title">
    A4H PAC New Hampshire
  </div>
</Link>

<Link to="/services/STATES/NEWJERSEY" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={newjersey} alt="A4H NEWJERSEY" />
  <div className="chapter-title">
    A4H PAC New Jersey
  </div>
</Link>

<Link to="/services/STATES/NEWYORK" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={newyork} alt="A4H NEWYORK" />
  <div className="chapter-title">
    A4H PAC New York
  </div>
</Link>

<Link to="/services/STATES/NORTHCAROLINA" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={northcarolina} alt="A4H NORTHCAROLINA" />
  <div className="chapter-title">
    A4H PAC North Carolina
  </div>
</Link>

<Link to="/services/STATES/OHIO" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={ohio} alt="A4H OHIO" />
  <div className="chapter-title">
    A4H PAC Ohio
  </div>
</Link>

<Link to="/services/STATES/OREGON" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={oregon} alt="A4H OREGON" />
  <div className="chapter-title">
    A4H PAC Oregon
  </div>
</Link>

<Link to="/services/STATES/PENNSYLVANIA" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={Pennsylvania} alt="A4H PENNSYLVANIA" />
  <div className="chapter-title">
    A4H PAC Pennsylvania
  </div>
</Link>

<Link to="/services/STATES/RHODEISLAND" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={rhode} alt="A4H RHODEISLAND" />
  <div className="chapter-title">
    A4H PAC Rhode Island
  </div>
</Link>

<Link to="/services/STATES/TENNESSEE" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={tennessee} alt="A4H TENNESSEE" />
  <div className="chapter-title">
    A4H PAC Tennessee
  </div>
</Link>

<Link to="/services/STATES/TEXAS" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={texas} alt="A4H TEXAS" />
  <div className="chapter-title">
    A4H PAC Texas
  </div>
</Link>

<Link to="/services/STATES/UTAH" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={utah} alt="A4H UTAH" />
  <div className="chapter-title">
    A4H PAC Utah
  </div>
</Link>

<Link to="/services/STATES/VIRGINIA" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={virginia} alt="A4H VIRGINIA" />
  <div className="chapter-title">
    A4H PAC Virginia
  </div>
</Link>

<Link to="/services/STATES/WASHINGTON" className="chapter-card">
  <div className="chapter-logo">
    <img src={logo} alt="A4H Logo" />
  </div>
  <img src={washington} alt="A4H WASHINGTON" />
  <div className="chapter-title">
    A4H PAC Washington
  </div>
</Link>

</div>
</div>
<div className="chapters-section upcoming-section">

  <div className="senate-bar">
  <span> Upcoming Chapters (12 Chapters)</span>
</div>

  <div className="chapters-grid">

  <div className="chapter-card" onClick={() => {setSelectedState("Alaska"); setShowFlyer(true);}}>
    <img src={alaska} alt="A4H Alaska" />
    <div className="chapter-title">A4H PAC Alaska</div>
  </div>

  <div className="chapter-card" onClick={() => {setSelectedState("Hawaii"); setShowFlyer(true);}}>
    <img src={hawaii} alt="A4H Hawaii" />
    <div className="chapter-title">A4H PAC Hawaii</div>
  </div>

  <div className="chapter-card" onClick={() => {setSelectedState("Idaho"); setShowFlyer(true);}}>
    <img src={idaho} alt="A4H Idaho" />
    <div className="chapter-title">A4H PAC Idaho</div>
  </div>

  <div className="chapter-card" onClick={() => {setSelectedState("Indiana"); setShowFlyer(true);}}>
    <img src={indiana} alt="A4H Indiana" />
    <div className="chapter-title">A4H PAC Indiana</div>
  </div>

  <div className="chapter-card" onClick={() => {setSelectedState("Iowa"); setShowFlyer(true);}}>
    <img src={iowa} alt="A4H Iowa" />
    <div className="chapter-title">A4H PAC Iowa</div>
  </div>

  <div className="chapter-card" onClick={() => {setSelectedState("Kentucky"); setShowFlyer(true);}}>
    <img src={kentucky} alt="A4H Kentucky" />
    <div className="chapter-title">A4H PAC Kentucky</div>
  </div>

  <div className="chapter-card" onClick={() => {setSelectedState("Minnesota"); setShowFlyer(true);}}>
    <img src={minnesota} alt="A4H Minnesota" />
    <div className="chapter-title">A4H PAC Minnesota</div>
  </div>

  <div className="chapter-card" onClick={() => {setSelectedState("Mississippi"); setShowFlyer(true);}}>
    <img src={mississippi} alt="A4H Mississippi" />
    <div className="chapter-title">A4H PAC Mississippi</div>
  </div>

  <div className="chapter-card" onClick={() => {setSelectedState("Montana"); setShowFlyer(true);}}>
    <img src={montana} alt="A4H Montana" />
    <div className="chapter-title">A4H PAC Montana</div>
  </div>

  <div className="chapter-card" onClick={() => {setSelectedState("Nebraska"); setShowFlyer(true);}}>
    <img src={nebraska} alt="A4H Nebraska" />
    <div className="chapter-title">A4H PAC Nebraska</div>
  </div>

  <div className="chapter-card" onClick={() => {setSelectedState("North Dakota"); setShowFlyer(true);}}>
    <img src={northdokota} alt="A4H North Dakota" />
    <div className="chapter-title">A4H PAC North Dakota</div>
  </div>

  <div className="chapter-card" onClick={() => {setSelectedState("Oklahoma"); setShowFlyer(true);}}>
    <img src={oklahoma} alt="A4H Oklahoma" />
    <div className="chapter-title">A4H PAC Oklahoma</div>
  </div>

  <div className="chapter-card" onClick={() => {setSelectedState("South Carolina"); setShowFlyer(true);}}>
    <img src={SouthCarolina} alt="A4H South Carolina" />
    <div className="chapter-title">A4H PAC South Carolina</div>
  </div>

  <div className="chapter-card" onClick={() => {setSelectedState("South Dakota"); setShowFlyer(true);}}>
    <img src={southdotaka} alt="A4H South Dakota" />
    <div className="chapter-title">A4H PAC South Dakota</div>
  </div>

  <div className="chapter-card" onClick={() => {setSelectedState("Vermont"); setShowFlyer(true);}}>
    <img src={vermont} alt="A4H Vermont" />
    <div className="chapter-title">A4H PAC Vermont</div>
  </div>

  <div className="chapter-card" onClick={() => {setSelectedState("West Virginia"); setShowFlyer(true);}}>
    <img src={westvirginia} alt="A4H West Virginia" />
    <div className="chapter-title">A4H PAC West Virginia</div>
  </div>

  <div className="chapter-card" onClick={() => {setSelectedState("Wisconsin"); setShowFlyer(true);}}>
    <img src={wisconsin} alt="A4H Wisconsin" />
    <div className="chapter-title">A4H PAC Wisconsin</div>
  </div>

  <div className="chapter-card" onClick={() => {setSelectedState("Wyoming"); setShowFlyer(true);}}>
    <img src={wyoming} alt="A4H Wyoming" />
    <div className="chapter-title">A4H PAC Wyoming</div>
  </div>

</div>
  </div>
</>
);
}

export default A4HChapters;
